import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class SectionIconContainerService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getSecao(id: string): Observable<any> {
    return this.getSecaoContents(id).pipe(
      map(res =>
        this.mapSection(this.extractResult(res))
      ),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.querySecaoContents[0].data;
  }

  private getSecaoContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        querySecaoContents(filter: "id eq '${id}'") {
          data {
            titulo {
              iv
            }
            subtitulo {
              iv
            }
            links {
              iv {
                descricaoLink
                link
                linkExterno
                titulo
                documento {
                  url
                }
                imagem {
                  url
                }
                imageHover {
                  url
                }
                hasHover
                modal {
                  id
                }
              }
            }
            rodape {
              iv
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private mapSection(section) {
    const links = section.links.iv.map(link => {
      return {
        link: link.link,
        externalLink: link.linkExterno,
        description: link.descricaoLink,
        title: link.titulo,
        image: link.imagem && link.imagem.length ? link.imagem[0].url : null,
        imageHover: link.imageHover && link.imageHover.length ? link.imageHover[0].url : null,
        hasHover: link.hasHover,
        modal: link.modal ? link.modal : null,
        document:
          link.documento && link.documento.length > 0
            ? link.documento[0].url
            : null
      };
    });
    const hasFooter = section.rodape !== null && section.rodape !== undefined;
    return {
      links,
      footer: hasFooter ? section.rodape.iv : section.rodape,
      description: section.subtitulo.iv,
      title: section.titulo.iv
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
